import type { ComponenteDidatico } from './catalogo'

type Detalhe = Omit<ComponenteDidatico, 'corSemantica' | 'acoes'>

export const DETALHES_ANATOMIA: readonly Detalhe[] = [
  {
    id: 'farois', nome: 'Faróis e indicadores dianteiros', categoria: 'carroceria', grupo: 'carroceria',
    descricao: 'Lentes, refletores, projetores e indicadores de direção na extremidade dianteira.',
    funcao: 'Iluminar a via e sinalizar presença ou intenção de manobra.',
    atencaoOperacional: 'Fragmentos, fiação e módulos podem estar expostos após impacto. Luzes apagadas não comprovam desligamento elétrico.',
  },
  {
    id: 'lanternas', nome: 'Lanternas traseiras', categoria: 'carroceria', grupo: 'carroceria',
    descricao: 'Conjuntos luminosos traseiros com funções de posição, frenagem e sinalização.',
    funcao: 'Tornar o veículo e suas manobras visíveis para quem vem atrás.',
    atencaoOperacional: 'Inspecione bordas quebradas e fios expostos ao acessar a traseira.',
  },
  {
    id: 'retrovisores', nome: 'Retrovisores externos', categoria: 'carroceria', grupo: 'carroceria',
    descricao: 'Carcaça, suporte e superfície espelhada em cada lateral; podem incorporar motores, câmeras e indicadores.',
    funcao: 'Ampliar a observação lateral e traseira do condutor.',
    atencaoOperacional: 'Podem dificultar passagens e apresentar fragmentos. Não são pontos de ancoragem ou estabilização.',
  },
  {
    id: 'gradeFrontal', nome: 'Grade e tomadas de ar', categoria: 'carroceria', grupo: 'carroceria',
    descricao: 'Aberturas e acabamento dianteiros à frente dos trocadores de calor.',
    funcao: 'Permitir passagem de ar para sistemas de arrefecimento; formas variam conforme a propulsão.',
    atencaoOperacional: 'Atrás da grade podem existir radiadores, ventoinhas, sensores e chicotes. A abertura aparente não indica um espaço livre.',
  },
  {
    id: 'suspensao', nome: 'Molas e amortecedores', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Conjuntos de mola helicoidal e amortecedor telescópico simplificados nas quatro rodas. A construção real varia entre eixos e modelos.',
    funcao: 'As molas sustentam a massa e armazenam energia elástica; os amortecedores dissipam energia e controlam as oscilações.',
    atencaoOperacional: 'Molas comprimidas armazenam energia. O movimento da suspensão altera a relação entre carroceria e rodas durante a estabilização.',
  },
  {
    id: 'suspensao.dianteira', nome: 'Molas e amortecedores dianteiros', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Os dois conjuntos dianteiros, ligados aos cubos e à carroceria na maquete.',
  },
  {
    id: 'suspensao.traseira', nome: 'Molas e amortecedores traseiros', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Os dois conjuntos traseiros. O suporte e os braços sob o piso aparecem também na vista Estrutura.',
  },
  {
    id: 'freiosDianteiros', nome: 'Discos de freio dianteiros', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Discos solidários aos cubos, com pistas de atrito e ventilação representadas. Exemplo didático de freio dianteiro a disco.',
    funcao: 'Transformar parte da energia do movimento em calor pelo atrito das pastilhas.',
    atencaoOperacional: 'Podem permanecer quentes. O freio de serviço não substitui a estabilização; confirme a construção dos freios no veículo real.',
  },
  {
    id: 'pincasFreio', nome: 'Pinças e pastilhas de freio', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Conjuntos que envolvem parte dos discos dianteiros; as pastilhas atuam nas duas faces.',
    funcao: 'Converter pressão hidráulica em força de aperto sobre o disco.',
    atencaoOperacional: 'Mangueiras, pinças e suportes podem estar danificados. Não são pontos universais de apoio para ferramentas.',
  },
  {
    id: 'servoFreio', nome: 'Servofreio', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Assistência de frenagem representada no lado do condutor, à frente da parede corta-fogo.',
    funcao: 'Reduzir o esforço necessário no pedal; sistemas podem usar assistência a vácuo ou elétrica.',
    atencaoOperacional: 'A assistência pode mudar após desligamento. Sua posição e tecnologia variam; não confundir com reservatório de combustível.',
    confirmarNaFicha: true,
  },
  {
    id: 'cilindroMestre', nome: 'Cilindro mestre e reservatório de freio', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Cilindro à frente do servofreio, com reservatório de fluido sobre ele.',
    funcao: 'Gerar pressão no circuito hidráulico de frenagem.',
    atencaoOperacional: 'Evite contato com fluidos e identifique vazamentos sem presumir sua composição pela cor.',
  },
  {
    id: 'moduloAbs', nome: 'Unidade hidráulica ABS / ESC', categoria: 'mecanica', grupo: 'seguranca',
    descricao: 'Bloco de válvulas, bomba e eletrônica, representado ao lado do cofre do motor.',
    funcao: 'O ABS modula a pressão para reduzir o bloqueio de rodas; o ESC pode frear rodas individualmente para ajudar no controle direcional.',
    atencaoOperacional: 'São recursos de segurança ativa durante a condução. Não imobilizam nem estabilizam o veículo após uma colisão.',
    confirmarNaFicha: true,
  },
  {
    id: 'linhasFreio', nome: 'Tubulações e flexíveis de freio', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Percurso esquemático do circuito dianteiro entre unidade hidráulica e freios. Não é um mapa real de tubulações.',
    funcao: 'Conduzir o fluido pressurizado aos mecanismos de frenagem.',
    atencaoOperacional: 'Tubulações de freio, combustível e cabos elétricos não devem ser identificados apenas pela posição ilustrada.',
    confirmarNaFicha: true,
  },
  {
    id: 'carterMotor', nome: 'Cárter e reservatório de óleo', categoria: 'mecanica', grupo: 'mecanica',
    descricao: 'Parte inferior do motor a combustão, abaixo do bloco. Forma e posição são simplificadas.',
    funcao: 'Fechar a parte inferior do motor e, neste exemplo de cárter úmido, armazenar óleo lubrificante.',
    atencaoOperacional: 'Pode conter óleo quente e vazar por dano. Não confundir sua aparência robusta com um ponto indicado para estabilização.',
  },
  {
    id: 'quadroInstrumentos', nome: 'Quadro de instrumentos', categoria: 'habitaculo', grupo: 'habitaculo',
    descricao: 'Mostradores e indicadores à frente do condutor, representados sem leituras reais.',
    funcao: 'Exibir velocidade, estado de funcionamento e alertas dos sistemas.',
    atencaoOperacional: 'Painel apagado e silêncio não comprovam desenergização; híbridos e elétricos podem estar prontos para se mover.',
  },
  {
    id: 'consoleCentral', nome: 'Console central', categoria: 'habitaculo', grupo: 'habitaculo',
    descricao: 'Acabamento entre os bancos dianteiros, distinto do túnel estrutural sob ele.',
    funcao: 'Alojar comandos e porta-objetos; pode recobrir chicotes e módulos.',
    atencaoOperacional: 'É um possível obstáculo na retirada lateral. Não presumir que o revestimento plástico esteja livre de sistemas por baixo.',
  },
  {
    id: 'seletorMarchas', nome: 'Seletor da transmissão', categoria: 'habitaculo', grupo: 'habitaculo',
    descricao: 'Comando de seleção de marcha ilustrativo no console; veículos podem usar alavanca, botão ou seletor eletrônico.',
    funcao: 'Permitir ao condutor selecionar a condição de funcionamento da transmissão.',
    atencaoOperacional: 'A indicação de estacionamento não garante retenção após dano. Confirme o procedimento do modelo e estabilize o veículo.',
  },
  {
    id: 'trilhosBancos', nome: 'Trilhos e fixações dos bancos', categoria: 'habitaculo', grupo: 'habitaculo',
    descricao: 'Duas guias sob cada banco dianteiro, fixadas ao assoalho. A maquete destaca a base que permanece na carroceria.',
    funcao: 'Guiar a regulagem longitudinal e transferir esforços do banco para a estrutura.',
    atencaoOperacional: 'Inspecione deformações, objetos presos e conexões sob o banco antes de qualquer movimentação.',
  },
  {
    id: 'isofix', nome: 'Ancoragens inferiores ISOFIX', categoria: 'retencao', grupo: 'seguranca',
    descricao: 'Pares de fixações rígidas entre assento e encosto nas posições traseiras laterais deste exemplo didático.',
    funcao: 'Conectar sistemas infantis compatíveis ao veículo; a instalação pode exigir top tether ou perna de apoio conforme o dispositivo e o manual.',
    atencaoOperacional: 'Identifique todas as ligações da cadeirinha. Não confundir a fixação do dispositivo ao carro com o cinto que retém a criança.',
    confirmarNaFicha: true,
  },
]